import React from "react";
import { Container } from "./style";
// eslint-disable-next-line no-unused-vars
import { Button, Dropdown, Avatar, Tag } from "antd";
// eslint-disable-next-line no-unused-vars
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  PauseCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoginInfo } from "../../store/features/UserInfo";
import { redirectToCognitoLogout } from "../../utils/cognitoOAuth";
import UserAvatar from "../../assets/User.png";

function buildVersionLabel() {
  const d = new Date();
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  const env = process.env.REACT_APP_CUSTOM_ENV ?? "";
  return `V${MM}${dd}${yy}-${env}`;
}

export default function Heading() {
  const userInfo = useSelector((state) => state.userInfo.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get subscription status display
  const getSubscriptionDisplay = () => {
    const status = userInfo?.subscriptionStatus?.status;
    if (!status) return null;

    const statusMap = {
      TRIAL: {
        text: "Start Free Trial",
        color: "blue",
        icon: <ClockCircleOutlined />,
      },
      ACTIVE: { text: "Active", color: "green", icon: <CheckCircleOutlined /> },
      TRIALING: {
        text: "Free Trial",
        color: "blue",
        icon: <ClockCircleOutlined />,
      },
      PAST_DUE: {
        text: "Upgrade",
        color: "orange",
        icon: <ExclamationCircleOutlined />,
      },
      CANCELED: {
        text: "Canceled",
        color: "red",
        icon: <CloseCircleOutlined />,
      },
      UNPAID: {
        text: "Upgrade",
        color: "red",
        icon: <ExclamationCircleOutlined />,
      },
      INCOMPLETE: {
        text: "Upgrade",
        color: "orange",
        icon: <ExclamationCircleOutlined />,
      },
      PAUSED: {
        text: "Paused",
        color: "default",
        icon: <PauseCircleOutlined />,
      },
      INCOMPLETE_EXPIRED: {
        text: "Upgrade",
        color: "red",
        icon: <CloseCircleOutlined />,
      },
    };

    return statusMap[status] || null;
  };

  // subscriptionDisplay is reserved for future use - keep getSubscriptionDisplay called to avoid unused warning
  const subscriptionDisplay = getSubscriptionDisplay();
  // Prevent unused variable warning
  void subscriptionDisplay;

  const onLogout = () => {
    dispatch(setLoginInfo({}));
    // Also clear Cognito's own Hosted UI session cookie (full-page redirect
    // through /logout) - otherwise a later Google sign-in can silently
    // reuse this session without ever prompting Google again.
    if (!redirectToCognitoLogout()) {
      navigate("/Login");
    }
  };

  const items = [
    {
      key: "2",
      label: (
        <button
          type="button"
          onClick={onLogout}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          Log out
        </button>
      ),
    },
  ];

  return (
    <Container>
      <div className="header-logo">
        <span className="main">UVITA</span>
        <span className="sub">PRO</span>
        <span className="version">{buildVersionLabel()}</span>
      </div>

      <Dropdown
        menu={{ items }}
        overlayStyle={{ minWidth: "150px" }}
        placement="bottom"
      >
        <Button className="user-name" type="text">
          <Avatar
            src={
              (userInfo.coach && userInfo.coach.profile_image) ||
              (userInfo.user && userInfo.user.profile_image) ||
              UserAvatar
            }
            className="mr-10"
          />
          {(userInfo.coach && userInfo.coach.name) ||
            (userInfo.user && userInfo.user.name)}
          {subscriptionDisplay && (
            <Tag
              color={subscriptionDisplay.color}
              icon={subscriptionDisplay.icon}
              style={{ marginLeft: "8px", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                const status = userInfo?.subscriptionStatus?.status;
                if (
                  [
                    "TRIAL",
                    "PAST_DUE",
                    "UNPAID",
                    "INCOMPLETE",
                    "PAUSED",
                  ].includes(status)
                ) {
                  navigate("/pricing");
                } else {
                  navigate("/AccountSettings");
                }
              }}
            >
              {subscriptionDisplay.text}
            </Tag>
          )}
        </Button>
      </Dropdown>
    </Container>
  );
}
